import React, { useState } from 'react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { PortfolioGrid } from '../components/PortfolioGrid';
import { ProjectDetail } from '../components/ProjectDetail';
import { ClientLogos } from '../components/ClientLogos';
import { Testimonials } from '../components/Testimonials';
import { ConsultationCTA } from '../components/ConsultationCTA';
import { projects } from '../data/site';
export function WorkPage() {
  const [openSlug, setOpenSlug] = useState<string | null>(null);
  const active = projects.find(project => project.slug === openSlug) ?? null;
  return <>
      <Seo title="Work — Selected Brand Identity & Design Projects | Morvix Graphics" description="Selected work from Morvix Graphics: identity systems, logo design and apparel branding created to solve problems, shape perceptions and bring ideas to life." path="/work" data-id="element-734" data-mp="tnilmszb6p4c" />
      <PageHeader eyebrow="Selected work" title="Work that earns|attention" lead="A selection of recent work created to solve problems, shape perceptions and bring ideas to life. Client confidentiality keeps most projects private — what you see here is published with permission." meta="400+ projects · 30+ brands" data-id="element-735" data-mp="fo9gqpgjzhfo" />
      <PortfolioGrid withHeading={false} withFilters onSelect={setOpenSlug} data-id="element-736" data-mp="3iekmebtvtcom" />
      {active ? <ProjectDetail project={active} onClose={() => setOpenSlug(null)} data-id="element-737" data-mp="9ziweteaj8qz" /> : null}
      <ClientLogos data-id="element-738" data-mp="eydlue6rjvk2" />
      <Testimonials data-id="element-739" data-mp="eyvru2j89o56" />
      <ConsultationCTA data-id="element-740" data-mp="exaxacwwy57b" />
    </>;
}